import axios from 'axios';
import store from "@/store";
import router from "@/router";
import { isPast } from "date-fns";

const http = axios.create({
  baseURL: window.env.API_BASE_URL
});

let timeoutInterceptor = null;
let tooManyRequestsInterceptor = null;

const timeoutHook = function(config) {
  const decodedToken = store.getters["auth/decodedToken"];
  const expires = new Date(decodedToken.exp * 1000);
  const isExpired = isPast(expires);

  if(isExpired) {
      store
        .dispatch('auth/logout')
        .then(() => {
          console.log('logged out because token expired')
          store.dispatch('search/resetApp');
          store.dispatch('ui/showToast', {
            type: 'error',
            message: 'session_expired'
          });
          router.push({name: 'login'}) 
        });
  }
  return config;
};

const tooManyRequestsHook = function(response) { 
  //doesn't do anything, we just need it for the error handler.
  return response;
}

function setXAuthHeader(token) {
  http.defaults.headers.common["Authorization"] = "Bearer " + token;
}

function removeXAuthHeader() {
  delete http.defaults.headers.common["Authorization"];
}

function attachTimeoutHook() {
  timeoutInterceptor = http.interceptors.request.use(timeoutHook, function(error) {
    return Promise.reject(error);
  });
}

function detachTimeoutHook() {
  http.interceptors.request.eject(timeoutInterceptor);
}

function attachTooManyRequestsHook() {
  if(store.state.auth.tooManyRequestsHookAttached) return;
  tooManyRequestsInterceptor = http.interceptors.response.use(tooManyRequestsHook, function(error) {
    if(error.response.status === 429) { //too many requests
      store.dispatch('ui/showToast', {
        type: 'error',
        message: 'too_many_requests'
      })
    }
    return Promise.reject(error.response);
  });
}

function detachTooManyRequestsHook() {
  http.interceptors.request.eject(tooManyRequestsInterceptor);
}


export {
  http,
  setXAuthHeader,
  removeXAuthHeader,
  attachTimeoutHook,
  detachTimeoutHook,
  attachTooManyRequestsHook,
  detachTooManyRequestsHook
};